"use strict";

var _slicedToArray = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SharedPlayerContexts = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var remotion_1 = require("remotion");

var volume_persistance_1 = require("./volume-persistance");

var SharedPlayerContexts = function SharedPlayerContexts(_ref) {
  var children = _ref.children,
      timelineContext = _ref.timelineContext,
      inputProps = _ref.inputProps,
      fps = _ref.fps,
      compositionHeight = _ref.compositionHeight,
      compositionWidth = _ref.compositionWidth,
      durationInFrames = _ref.durationInFrames,
      component = _ref.component,
      numberOfSharedAudioTags = _ref.numberOfSharedAudioTags;
  var compositionManagerContext = (0, react_1.useMemo)(function () {
    return {
      compositions: [{
        component: component,
        durationInFrames: durationInFrames,
        height: compositionHeight,
        width: compositionWidth,
        fps: fps,
        id: 'player-comp',
        props: inputProps,
        nonce: 777,
        scale: 1,
        folderName: null,
        defaultProps: undefined,
        parentFolderName: null
      }],
      folders: [],
      registerFolder: function registerFolder() {
        return undefined;
      },
      unregisterFolder: function unregisterFolder() {
        return undefined;
      },
      currentComposition: 'player-comp',
      registerComposition: function registerComposition() {
        return undefined;
      },
      registerSequence: function registerSequence() {
        return undefined;
      },
      sequences: [],
      setCurrentComposition: function setCurrentComposition() {
        return undefined;
      },
      unregisterComposition: function unregisterComposition() {
        return undefined;
      },
      unregisterSequence: function unregisterSequence() {
        return undefined;
      },
      registerAsset: function registerAsset() {
        return undefined;
      },
      unregisterAsset: function unregisterAsset() {
        return undefined;
      },
      currentCompositionMetadata: null,
      setCurrentCompositionMetadata: function setCurrentCompositionMetadata() {
        return undefined;
      },
      assets: []
    };
  }, [component, durationInFrames, compositionHeight, compositionWidth, fps, inputProps]);

  var _ref2 = (0, react_1.useState)(false),
      _ref3 = _slicedToArray(_ref2, 2),
      mediaMuted = _ref3[0],
      setMediaMuted = _ref3[1];

  var _ref4 = (0, react_1.useState)((0, volume_persistance_1.getPreferredVolume)()),
      _ref5 = _slicedToArray(_ref4, 2),
      mediaVolume = _ref5[0],
      setMediaVolume = _ref5[1];

  var mediaVolumeContextValue = (0, react_1.useMemo)(function () {
    return {
      mediaMuted: mediaMuted,
      mediaVolume: mediaVolume
    };
  }, [mediaMuted, mediaVolume]);
  var setMediaVolumeAndPersist = (0, react_1.useCallback)(function (vol) {
    setMediaVolume(vol);
    (0, volume_persistance_1.persistVolume)(vol);
  }, []);
  var setMediaVolumeContextValue = (0, react_1.useMemo)(function () {
    return {
      setMediaMuted: setMediaMuted,
      setMediaVolume: setMediaVolumeAndPersist
    };
  }, [setMediaVolumeAndPersist]);
  return (0, jsx_runtime_1.jsx)(remotion_1.Internals.CanUseRemotionHooksProvider, {
    children: (0, jsx_runtime_1.jsx)(remotion_1.Internals.Timeline.TimelineContext.Provider, {
      value: timelineContext,
      children: (0, jsx_runtime_1.jsx)(remotion_1.Internals.CompositionManager.Provider, {
        value: compositionManagerContext,
        children: (0, jsx_runtime_1.jsx)(remotion_1.Internals.PrefetchProvider, {
          children: (0, jsx_runtime_1.jsx)(remotion_1.Internals.DurationsContextProvider, {
            children: (0, jsx_runtime_1.jsx)(remotion_1.Internals.MediaVolumeContext.Provider, {
              value: mediaVolumeContextValue,
              children: (0, jsx_runtime_1.jsx)(remotion_1.Internals.SetMediaVolumeContext.Provider, {
                value: setMediaVolumeContextValue,
                children: (0, jsx_runtime_1.jsx)(remotion_1.Internals.SharedAudioContextProvider, {
                  numberOfAudioTags: numberOfSharedAudioTags,
                  children: children
                })
              })
            })
          })
        })
      })
    })
  });
};

exports.SharedPlayerContexts = SharedPlayerContexts;